import { Component, OnInit } from '@angular/core';
import { ReportSaldosModel } from 'src/app/models/report.model';
import { ReportService } from 'src/app/services/report.service';
import { MessageService } from 'primeng/api';
import { ExcelService } from 'src/app/services/excel.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-rpt-saldo',
  templateUrl: './rpt-saldo.component.html',
  styleUrls: ['./rpt-saldo.component.css']
})
export class RptSaldoComponent implements OnInit {

  statusOptions: SelectItem[];
  selectedOption: string;
  colsTablaRptSaldos;
  datasourceRptSaldos: ReportSaldosModel[] = [];
  status: string;
  disabledStatus: boolean = true;
  loading: boolean = false;
  disabledButton: boolean = true;
  
  constructor(private reportService: ReportService,
    private messageService: MessageService,
    private excelService: ExcelService) { }

  ngOnInit() {
    this.createColumnsTablaRptSaldo();
    this.createStatusOptions();
  }

  createStatusOptions(){
    this.statusOptions = [
      {label:'Seleccione Estado', value:null},
      {label:'Activo', value: 'AC'},
      {label:'Inactivo', value: 'IN'},
      {label:'Distribuido', value: 'DI'},
      {label:'Cancelado', value: 'CA'}
  ];
  }

  createColumnsTablaRptSaldo(){
    this.colsTablaRptSaldos = [
        { field: 'ORDEN_COMPRA', header: 'Orden de Compra', width: '8%', align : 'center'},
        { field: 'CLIENTE', header: 'Cliente', width: '15%', align : 'center'},
        { field: 'MODELO_GIFT_CARD', header: 'Modelo Tarjeta', width: '15%', align : 'center'},
        { field: 'NUMERO_TARJETA', header: 'Nro. Tarjeta', width: '8%', align : 'center'},
        { field: 'SECUENCIAL', header: 'Secuencial', width: '5%', align : 'center'},
        { field: 'ESTADO', header: 'Estado', width: '6%', align : 'center'},
        { field: 'USUARIO', header: 'Usuario', width: '5%', align : 'center'},
        { field: 'MONTO_ACTIVACION', header: 'Monto Activación', width: '5%', align : 'center'},
        { field: 'SALDO', header: 'Saldo', width: '5%', align : 'center'}
    ];
  }

  populateTablaRptSaldos(){
    this.loading = true;
    if (this.selectedOption == "STA" && (!(this.status))){
      this.messageService.add({severity:'error', summary: 'Error', detail:'Debe seleccionar un estado.'});
      this.loading = false;
    } 
    else{
      let params = {
        "p_status_gift_card" : this.status
      }
      console.log(params);
      this.reportService.GetReporteSaldos(params).subscribe(
        (response : ReportSaldosModel[]) =>{
          this.datasourceRptSaldos = response;
          this.loading = false;
          if (this.datasourceRptSaldos.length == 0){
            this.messageService.add({severity:'warn', summary: 'Alerta', detail:'No se encontraron resultados para la búsqueda ingresada'});
          }
        },
        (error) => {
          this.loading = false;
          this.messageService.add({severity:'error', summary: 'Error', detail:'Se produjo un error al realizar la consulta.'});
        });    
    }
  }

  exportAsXLSX():void {
    if (this.datasourceRptSaldos.length == 0){
      this.messageService.add({severity:'warn', summary: 'Alerta', detail:'No existen información para la exportación'});
      return;
    }
    this.excelService.exportAsExcelFile(this.datasourceRptSaldos, 'report');
  }

  changeSelectionOption(){
    this.disabledButton = false;
    switch(this.selectedOption){
      case "STA":
          this.disabledStatus = false;            
          break;      
      default:
          break;
    }
  }
}
